









































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Response } from '@/models/response';
import { CustomerInfoViewModel } from '@/models/fixedops/repairorder';
import {
  MessageMediaViewModel,
  MessagesViewModel,
  NewMessage,
  MessageCreateViewModel,
  MessageAttachmentViewModel,
} from '@/models/telephony/message';
import { VFields } from '@/models/v-fields';
import { Template } from '@/models/template';
import {
  ConversationTypes,
  MetadataType,
  MetadataKeyIdentifier,
  TemplateAssociationType,
} from '@/enums/enums';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { FileHelper as _file } from '@/helper/file.helper';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {
  repairOrderService,
  attachmentService,
  messageService,
  templateService,
  customerService,
} from '@/shared';
import VAlynkFileUpload from '@/components/custom-templates/v-alynk-file-upload.vue';

@Component({
  props: ['methodName', 'progress', 'query', 'type'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class SendMessageComponent extends Base {
  public pagedAttachments: MessageAttachmentViewModel[] = [];
  public pagedTextLog: any[] = [];
  public pagination = new PaginationModel('name');
  public attachmentPagination = new PaginationModel('name');

  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public disableSubmitButton: boolean = false;

  public loading: boolean = false;
  public attachmentloading: boolean = false;
  public fileRef: any;
  public flags: any = {
    showForm: false,
    showEmailPopup: false,
  };
  public showAttachmentDetails: IDialogOption = {
    width: 500,
    title: this.$parent.$t(
      'sendMessage.roAttachmentDetailDialog.title'
    ) as string,
    model: false,
  };

  public constants: any = {
    customerKey: '',
    recordKey: '0',
    vin: '',
  };

  public sType: string = 'o';
  public roNumber: string = '';
  public templateType: string = '';

  public templates: Template[] = [];
  public customerInfo: CustomerInfoViewModel = {};
  public messageToSend: MessageCreateViewModel = new MessageCreateViewModel(
    ConversationTypes[ConversationTypes.Text]
  );

  public headers: VHeaders[] = [
    {
      align: 'left',
      text: this.$parent.$t('sendMessage.rOSendMessageGrid.date') as string,
      value: 'createdAt',
      fieldType: 'date',
    },
    {
      align: 'left',
      text: this.$parent.$t('sendMessage.rOSendMessageGrid.from') as string,
      value: 'messageJson.from',
    },
    {
      align: 'left',
      text: this.$parent.$t('sendMessage.rOSendMessageGrid.to') as string,
      value: 'messageJson.to',
    },
    {
      align: 'left',
      text: this.$parent.$t('sendMessage.rOSendMessageGrid.message') as string,
      value: 'messageJson.textJson.body',
    },
    {
      align: 'left',
      text: this.$parent.$t('sendMessage.rOSendMessageGrid.status') as string,
      value: `messageJson.status`,
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'sendMessage.rOSendMessageGrid.attachment'
      ) as string,
      isNotDataProp: true,
      sortable: false,
    },
  ];
  public attachmentHeaders: VHeaders[] = [
    {
      align: 'left',
      text: this.$parent.$t(
        'sendMessage.rOAttachmentDetailGrid.name'
      ) as string,
      value: 'uri.substring(item.uri.lastIndexOf("/")+1,item.uri.length)',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: this.$parent.$t(
        'sendMessage.rOAttachmentDetailGrid.action'
      ) as string,
      sortable: false,
    },
  ];

  public actions = [
    {
      type: 'button',
      icon: 'far fa-folder-open',
      title: this.$parent.$t(
        'sendMessage.rOSendMessageGrid.gridActions.showFolder'
      ) as string,
      disable: (model: MessagesViewModel) => {
        return (
          model.attachments != null &&
          model.attachments &&
          model.attachments.length === 0
        );
      },
      action: (model: MessagesViewModel) => {
        this.openAttachmentPopup(model);
      },
    },
  ];
  public attachmentAction: any[] = [];

  public close() {
    this.$emit('sendMessageDialog', false);
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({ name: 'app.repairorders.open' });
    } else if (methodName === 'sendMessage') {
      if (this.form.$valid) {
        this.sendMessage();
      } else {
        this.showAlert(false, this.$t('sendMessage.alertFormInvalid'));
      }
    } else if (methodName === 'partSales') {
      if (!this.sType || this.sType === 'partsales') {
        this.$router.push({ name: 'app.partsales' });
      }
    } else if (methodName === 'viewRO') {
      this.$router.push({
        name: 'app.repairorders.detail',
        params: { roNumber: this.constants.recordKey },
      });
    }

    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    if (
      (this.sType && this.sType === 'n') ||
      !this.sType ||
      this.sType === 'o'
    ) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$t('sendMessage.btnROList'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$t('sendMessage.btnROList'),
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
    }
    if (this.sType && this.sType === 'o') {
      buttons.push({
        id: '3',
        type: 'button',
        title: this.$t('sendMessage.btnViewRO'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$t('sendMessage.btnViewRO'),
        click: 'viewRO',
        icon: 'fas fa-arrow-left',
      });
    }

    if (!this.sType || this.sType === 'partsales') {
      buttons.push({
        id: '2',
        type: 'button',
        title: this.$t('sendMessage.btnPartSales'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$t('sendMessage.btnPartSales'),
        click: 'partSales',
        icon: 'fas fa-arrow-left',
      });
    }

    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    const constKeys = Object.keys(this.constants);
    constKeys.forEach((key) => {
      if (this.$props.query[key]) {
        this.constants[key] = ((this.$props.query[key] as string) || '').trim();
      }
    });

    this.sType = this.$props.query.sType as string;
    this.roNumber = this.constants.recordKey;

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.messageToSend.recordIdentifier = this.$props.type;
    this.messageToSend.recordKey = this.constants.recordKey;
    this.messageToSend.vin = this.constants.vin;

    switch (this.messageToSend.recordIdentifier) {
      case MetadataType[MetadataType.Deal]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.DealNumber];
        this.templateType = TemplateAssociationType.Deal.toString();
        break;
      case MetadataType[MetadataType.Appointment]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.AppointmentNumber];
        this.templateType = TemplateAssociationType.Appointment.toString();
        break;
      case MetadataType[MetadataType.AR]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.CustomerNumber];
        this.templateType = TemplateAssociationType.Customer.toString();
        break;
      case MetadataType[MetadataType.RO]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.RepairOrderNumber];
        this.templateType = TemplateAssociationType.Service.toString();
        break;
      case MetadataType[MetadataType.PartSales]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.InvoiceNumber];
        this.templateType = TemplateAssociationType.Parts.toString();
        this.sType = 'partsales';
        break;
      default:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.Unknown];
        break;
    }

    this.attachmentAction = [
      {
        type: 'button',
        icon: 'fa fa-eye',
        title: this.$parent.$t(
          'sendMessage.rOAttachmentDetailGrid.gridActions.viewAttachment'
        ) as string,
        action: (model: any) => {
          attachmentService.viewAttachmentAsync(model.attachmentId);
        },
      },
    ];

    this.setFields();
    this.getExistingMessages();
    this.getCustomerInfo();
    this.getTemplates();
  }

  public openAttachmentPopup(model: MessagesViewModel) {
    try {
      this.attachmentloading = true;
      if (model.attachments && model.attachments.length > 0) {
        this.pagedAttachments = model.attachments;
        this.pagination.totalItems = model.attachments.length;
        this.showAttachmentDetails.model = true;
      }
    } finally {
      this.attachmentloading = false;
    }
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'to',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: this.$parent.$t('sendMessage.to') as string,
          required: true,
          text: 'name',
          value: 'value',
          disabled: false,
          items: this.customerInfo.phoneNumberSelectList,
          altag: 'To',
          loading: false,
          rules: [
            v => this.required('To', v)
          ]
        },
      },
      {
        key: 'customerName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: this.$parent.$t('sendMessage.customerName') as string,
          required: true,
          disabled: true,
          loading: false,
          rules: [
            v => this.required('Customer Name', v)
          ]
        },
      },
      {
        key: 'recordKey',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          label: this.$parent.$t('sendMessage.ro') as string,
          required: false,
          disabled: true,
          elementStyle:
            !this.constants.recordKey || this.constants.recordKey === '0'
              ? 'display:none'
              : '',
          loading: false,
        },
      },
      {
        key: 'template',
        type: 'v-alynk-select',
        // required: true,
        templateOptions: {
          label: this.$parent.$t('sendMessage.template') as string,
          // required: true,
          disabled: false,
          time: true,
          value: 'id',
          text: 'name',
          items: this.templates,
          altag: 'Template',
          events: {
            onChange: async (items: Template[], value) => {
              if (!value) {
                    this.messageToSend.body = '';
                    
                    // Force form validation refresh
                    this.$nextTick(() => {
                      this.form.updateValueAndValidity();
                    });

                    return;
                  }

              try {
                this.formlyShowSkeleton(this.formFields, 'body');
                const response = await templateService.getTemplateDescription(
                  value,
                  this.messageToSend.customerName,
                  this.messageToSend.vin,
                  '',
                  '',
                  this.constants.recordKey
                );
                this.messageToSend.body = response.text;
              } finally {
                this.formlyHideSkeleton(this.formFields, 'body');
              }
            },
          },
          // rules:[
          //   v => this.required('Template',v)
          // ],
          loading: false,
        },
      },
      {
        key: 'body',
        type: 'v-alynk-textarea',
        required: true,
        templateOptions: {
          label: this.$parent.$t('sendMessage.body') as string,
          required: true,
          disabled: false,
          multiple: false,
          loading: false,
          rules: [
            v => this.required('Body', v)
          ]
        },
      },
      {
        key: 'files',
        type: 'v-alynk-file-upload',
        required: false,
        templateOptions: {
          counter: 250,
          label: this.$parent.$t('sendMessage.attachment') as string,
          validations: '',
          required: false,
          disabled: false,
          multiple: true,
          events: {
            onChange: (files, ref) => {
              if (files && files.length > 0) {
                this.fileRef = ref;
                this.messageToSend.files = [];
                files.forEach((file) => {
                  _file.getFileBytes(file.file, (base64) => {
                    this.messageToSend.files.push({
                      base64,
                      extension: file.name.substring(
                        file.file.name.lastIndexOf('.')
                      ),
                      fileName: file.file.name,
                      fileSize: file.file.size,
                    });
                  });
                });
              }
            },
          },
          loading: false,
        },
      },
    ];
  }

  public async getTemplates(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields, 'template');
      const response = await templateService.getStoreTemplates(this.templateType);
      this.templates = response.results;
      this.setFieldSelectItems('template', this.templates);
    } finally {
      this.formlyHideSkeleton(this.formFields, 'template');
    }
  }

  public async getCustomerInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields, 'to');
      this.formlyShowSkeleton(this.formFields, 'customerName');
      const response = await customerService.getCustomerInfoAsync(
        this.constants.customerKey
      );
      this.customerInfo = response;
      this.setFieldSelectItems('to', this.customerInfo.phoneNumberSelectList);

      this.messageToSend.customerKey = this.customerInfo.customerKey;
      this.messageToSend.customerName = this.customerInfo.customerName;
      if (this.customerInfo.phoneNumberSelectList.length === 1) {
        this.messageToSend.to = this.customerInfo.phoneNumberSelectList[0].value;
      }
    } finally {
      this.formlyHideSkeleton(this.formFields, 'to');
      this.formlyHideSkeleton(this.formFields, 'customerName');
    }
  }

  public async getExistingMessages(): Promise<void> {
    if (this.constants.customerKey && this.messageToSend.recordIdentifier) {
      try {
        this.loading = true;
        const response = await messageService.getExistingMessages(
          this.constants.customerKey,
          this.constants.recordKey,
          this.messageToSend.recordIdentifier
        );

        this.pagedTextLog = response.existingMessages.results;
        this.pagination.totalItems = response.existingMessages.results.length;
      } finally {
        this.loading = false;
      }
    }
  }

  public validateSendMessage(): Vue & { validate: () => boolean } {
    return this.$refs.messageForm as Vue & { validate: () => boolean };
  }

  public async sendMessage(): Promise<void> {
    if (this.validateSendMessage().validate()) {
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        await messageService.sendMessage(this.messageToSend);
        this.showAlert(true, this.$t('sendMessage.alertMessageSEnd'));
        await this.getExistingMessages();
      } finally {
        this.disableSubmitButton = false;
        this.messageToSend.to = '';
        this.messageToSend.body = '';
        this.messageToSend.template = '';
        this.messageToSend.files = [];
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }

  public setFieldSelectItems(key, value): void {
    const field = this.formFields.find((m) => {
      return m.key === key;
    });
    if (field) {
      this.$set(field.templateOptions, 'items', value);
    }
  }

  public resetAttachment(key, value): void {
    const field = this.formFields.find((m) => {
      return m.key === key;
    });
    if (field) {
      this.$set(field.templateOptions, 'files', value);
    }
  }

  public updateFlag(flag, value): void {
    this.flags[flag] = value;
  }

  public updatePaging(paging): void {
    this.pagination = paging;
  }

  public updateAttachmentPaging(paging): void {
    this.attachmentPagination = paging;
  }
}
